import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import MinimalButton from "../../revamped/button/MinimalButton";
import TextField from "../../revamped/form/TextField";
import StatusMessage from "../../revamped/StatusMessage";

const Addon = styled.div`
  display: flex;
  gap: 12px;
`;

// https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression#comment53354378_201447
const SIMPLE_EMAIL_REGEX = String.raw`[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}`;

interface InviteFieldProps
  extends Omit<React.ComponentProps<typeof TextField>, "onSubmit"> {
  loading?: boolean;
  error?: string;
  success?: boolean;
  testId?: string;
  onReset?: () => void;
  onSubmit: (emails: string[]) => void;
}

const InviteField = ({
  error,
  loading,
  success,
  testId,
  onReset,
  onSubmit,
  ...props
}: InviteFieldProps) => {
  const [value, setValue] = useState("");

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);

    if (error || success) {
      onReset?.();
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (event.currentTarget.reportValidity()) {
      onSubmit(value.split(","));
    }
  };

  useEffect(() => {
    if (success) {
      setValue("");
    }
  }, [success]);

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        {...props}
        type="email"
        multiple={true}
        pattern={SIMPLE_EMAIL_REGEX}
        title="Please enter valid emails"
        data-test-id={testId ? `input-${testId}-email` : undefined}
        value={value}
        readOnly={loading}
        onChange={handleInputChange}
        addon={
          <Addon>
            {error || success ? (
              <StatusMessage status={error ? "error" : "success"}>
                {error || "email sent"}
              </StatusMessage>
            ) : null}

            {success ? null : (
              <MinimalButton
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- FIXME
                data-test-id={`button-${testId}`}
                type="submit"
                disabled={loading}
              >
                Invite
              </MinimalButton>
            )}
          </Addon>
        }
      />
    </form>
  );
};

export default InviteField;
